export default "../css/6421ceffe231962052e625ced1cfad4d.ttf";